import { Link } from 'react-router-dom'
import { Header } from '../components/Header.jsx'
import menuData from '../data/menu.json'

export const MenuView = () => {
  return (
    <>
      <Header title='Menu' description='Get started...' className='menu-pad' />
      <menu>
        {menuData.data.map((item, index) => (
          <li key={index}>
            {item.route ? (
              <Link to={item.route} className='icon_grid'>
                <span className='material-symbols-rounded'>{item.icon}</span>
                <div>
                  <div className='go_to'>
                    <span>{item.title}</span>
                    <span className='material-symbols-rounded'>
                      arrow_right_alt
                    </span>
                  </div>
                  <span className='subtext'>{item.description}</span>
                </div>
              </Link>
            ) : (
              <a
                href={item.hyperlink}
                className='icon_grid'
                target='_blank'
                rel='noopener noreferrer'
                key={index}>
                <span className='material-symbols-rounded'>{item.icon}</span>
                <div>
                  <div className={`go_to ${item.hyperlink && 'go_to-alt'}`}>
                    <span>{item.title}</span>
                    <span className='material-symbols-rounded'>
                      open_in_new
                    </span>
                  </div>
                  <span className='subtext'>{item.description}</span>
                </div>
              </a>
            )}
          </li>
        ))}
      </menu>
    </>
  )
}

export const getViewData = (route) =>
  menuData.data.find((item) => item.route === route)
